export default __webpack_public_path__ + "static/media/background.c406c00e.svg";